import { Navigate } from 'react-router-dom';

import { ForbiddenPage } from '@/components/ForbiddenPage';
import { Spinner } from '@/components/ui/Spinner';
import { useAuth } from '@/hooks/useAuth';

import type { Role } from '@shared/types/auth';
import type { JSX } from 'react';

type RequireRoleProps = {
  roles: readonly Role[];
  children: React.ReactNode;
};

export function RequireRole({ roles, children }: RequireRoleProps): JSX.Element {
  const { user, claims, loading } = useAuth();

  if (loading) return <Spinner />;
  if (user === null) return <Navigate to="/signin" replace />;
  if (claims === null || !roles.includes(claims.role)) return <ForbiddenPage />;

  return <>{children}</>;
}
